import { render, staticRenderFns } from "./statisticsOfImportEntities.vue?vue&type=template&id=7a6ca8fa&scoped=true&"
import script from "./statisticsOfImportEntities.vue?vue&type=script&lang=js&"
export * from "./statisticsOfImportEntities.vue?vue&type=script&lang=js&"
import style0 from "./statisticsOfImportEntities.vue?vue&type=style&index=0&id=7a6ca8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6ca8fa",
  null
  
)

export default component.exports